import {NetworkRequest} from "@/backoffice/components/fetch.ts";
import {openPanel, closePanel} from "@/backoffice/components/form/components/panels";


// noinspection JSIgnoredPromiseFromCall
if ( window.isEmbeddedCalendar ) {

    class CalendarDisplay {
        constructor() {
            /** @type {CalendarUI} CalendarUI Class */
            this.calendarUI = new CalendarUI(this);
            this.displayElement = new DisplayElement;

            this.companyParent = document.querySelector('.company');
            this.popup = document.querySelector('.company-popup');

            document.querySelector('.company-open-select').on('click', () => this.popup.classList.remove('hidden'));
            document.querySelector('.add-circle').on('click', () => this.popup.classList.remove('hidden'));
            document.querySelector('.company-popup').on('click', (event) => {
                if (event.target === this.popup) {
                    this.popup.classList.add('hidden');
                }
            });

            document.querySelector('.company-popup .apply-company-button').on('click', () => {
                if (this.canCloseDropdown()) {
                    this.popup.classList.add('hidden');
                    this.calendarUI.showCompany();
                }
            });


            /** @type {AvailabilityProvider} Availability Provider Class */
            this.provider = new AvailabilityProvider(this);

            /** @type {{pets: number, children: number, adults: number, babies: number}} Travel company object */
            this.company = {
                adults: 0,
                children: 0,
                babies: 0,
                pets: 0,
            }

            /** @type {Month[]} */
            this.months = [];
            this.parent = document.querySelector('.calendar-container');


            /**
             * Generates Months and keeps track of when months have finished generating.
             */

            let genMonthsDone = new Promise((resolve, reject) => {
                this.genMonths();
                resolve();
            });

            genMonthsDone.then(
                (resolve) => {
                    this.allTableContainers = Array.from(document.querySelectorAll('.tableContainer'));
                    this.calendarUI.checkFirstStartAvailable();
                });

            this.totalPeople = '';

            /** @type {number} Calendar height calculation */
            this.calendarMonthHeight = document.querySelector('.tableContainer').offsetHeight;

            /** @type {Day}  */
            this.startDay = null;

            /** @type {Day}  */
            this.endDay = null;

            /** @type {Day}  */
            this.hoverEndDay = null;

            /**@type {Element} Loader */
            this.loader = document.querySelector('.loader');
            this.scrim = document.querySelector('.scrim');
            this.loadIndicator = new CircularIndicator(this.loader);

            this.includedText = document.querySelector('.included-text');
            this.optionalText = document.querySelector('.optional-text');

            /** @type {Element} */
            this.companyInfo = document.querySelector('.popup-input');
            this.bookOverlayCompany = document.querySelector('.show-company');

            if (window.bookable) {
                /** @type {Element} All inputs except for pet inputs */
                this.companyInputContainer = document.querySelector('.company-select');

                // My eyes
                this.companyInputContainer.on('click', '.icon-button', (event) => {
                    const button = event.target.closest('.icon-button');

                    if (! button.classList.contains('half-opacity-scaled-down')) {
                        const input = event.target.closest('.input-parent').querySelector('input');

                        if (input.name === 'input-adults') {
                            this.displayElement.hideElement(document.querySelector('.minimum-select-desc'));
                        }

                        if (button.classList.contains('minus')) {
                            input.value = parseInt(input.value) - 1;
                        } else {
                            input.value = parseInt(input.value) + 1;
                        }
                    }

                    this.checkValue();
                });

                this.companyInputs = this.companyInputContainer.querySelectorAll('.inside-popup-input');

                this.companyInputs.forEach(popupInput => {

                    popupInput.parentNode.parentNode.querySelector('.icon-button.minus').name = (popupInput.name.replace('input-', 'decrease-button '));
                    popupInput.parentNode.parentNode.querySelector('.icon-button.plus').name = (popupInput.name.replace('input-', 'increment-button '));
                    popupInput.parentNode.parentNode.querySelector('.icon-button').classList.add('default-transition');

                    popupInput.addEventListener('change', this.checkValue.bind(this));
                });

                this.checkValue();

                this.bookOverlayCompany.addEventListener('click', () => {
                    this.popup.classList.remove('hidden');
                    if ( window.innerWidth < 1281 ) {
                        this.calendarUI.hideBookOverlay();
                    }
                });

                this.bookCompanyInfo = document.querySelector('.book-company .popup-input');

                /** Event listeners for Book hrefs */
                document.querySelector('.bookButton').addEventListener('click', () => {
                    this.calendarUI.book();
                });

                this.companyInputContainer.querySelectorAll('input').forEach(input => {
                    input.addEventListener('change', () => {
                        this.calendarUI.showCompany();
                    });
                });

                this.calendarUI.showCompany();
            }

            document.querySelectorAll('.icon-button').forEach(iconButton => {
                iconButton.classList.add('animated');
            });

            this.returnText = document.querySelector('.return-text');

            this.returnText.addEventListener('click', () => {
                this.calendarUI.hideBookOverlay();
            });

            document.querySelectorAll('.icon-button.plus.opacity-0').forEach(iconButtonPlus => {
                iconButtonPlus.addEventListener('click', () => {
                    this.displayElement.showElement(document.querySelector('.too-many-selected-alert'));
                });
            })
        }

        /**
         * If there's one or more adults selected, let the user close the dropdown. If the user is on the small layout, open the bookoverlay.
         * @return boolean
         */
        canCloseDropdown() {
            if (this.company.adults >= 1) {
                this.calendarUI.hidePanel();
                if (this.startDay) {
                    this.provider.netReq();
                }
                if (this.endDay && window.innerWidth < 1281) {
                    this.calendarUI.showBookOverlay();
                }

                return true;
            }

            this.displayElement.showElement(document.querySelector('.minimum-select-desc'));

            return false
        }

        /**
         * Caps the input value at the amount of people the user can still select.
         * @void
         */
        checkValue() {
            // Reference to how many people the user has selected with the popup inputs
            let totalPeopleSelected = 0;
            this.companyInputs.forEach(popupInput => { // Checks if selected babies exceeds extra amount of babies, once it does, don't allow the user to select more babies than the maximum amount of people.
                if (Number(popupInput.value) > Number(popupInput.max)) { // Caps user's typing value at the maximum input value.
                    popupInput.value = popupInput.max;
                }
                if (popupInput.name === 'input-babies') {
                    totalPeopleSelected += Math.max(Number(popupInput.value) - occupationInfo.extraBabies, 0);
                } else {
                    totalPeopleSelected += Number(popupInput.value);
                }
            });

            // Gets the maximum amount of people for this house.
            const numPeople = occupationInfo.numPeople;

            this.companyInputs.forEach(popupInput => {

                let inputDecreaseButton = document.querySelector('.icon-button.minus[name="' + popupInput.name.replace('input-', 'decrease-button ') + '"]');
                let inputIncrementButton = document.querySelector('.icon-button.plus[name="' + popupInput.name.replace('input-', 'increment-button ') + '"]');
                // Calculates how much the max value should be
                this.inputMax = numPeople - totalPeopleSelected + Number(popupInput.value);

                // If the current input is linked to babies, add the extra amount of babies
                if (popupInput.name === 'input-babies') {
                    this.inputMax += Math.max(occupationInfo.extraBabies - Number(popupInput.value), 0);
                }

                // Sets the max value for the inputs.
                popupInput.max = this.inputMax;

                if (Number(popupInput.value) === Number(popupInput.max)) { // Executes when max value has been reached.
                    inputIncrementButton.classList.add('half-opacity-scaled-down');

                } else if (Number(popupInput.max) > Number(popupInput.value)) { // Executes when max value hasn't been reached yet.
                    inputIncrementButton.classList.remove('half-opacity-scaled-down');

                }

                if (Number(popupInput.value) === Number(popupInput.min)) { // Executed when min value has been reached.
                    inputDecreaseButton.classList.add('half-opacity-scaled-down');
                } else {
                    inputDecreaseButton.classList.remove('half-opacity-scaled-down');
                }

                switch (popupInput.name) {
                    case 'input-adults': this.company.adults = parseInt(popupInput.value); break;
                    case 'input-children': this.company.children = parseInt(popupInput.value); break;
                    case 'input-babies': this.company.babies = parseInt(popupInput.value); break;
                    case 'input-pets': this.company.pets = parseInt(popupInput.value); break;
                }
            });
        }

        /**
         * Generates months.
         * @void
         */
        genMonths() {
            for (let i = 0; i < 18; i++) {
                this.months.push(new Month(new Date().startOfMonth().startOfDay().addMonths(i), this));
            }
        }

        /**
         * Marks days in between the arrival date and the departure dates the user hovers over.
         * @param {Day} day
         */
        hoverDay(day = null) {
            if (!day) {
                this.selectDaysBetween();
                return;
            }

            // Deselects the user's previous hover, only if it's not a start or end date.
            if (this.hoverEndDay && this.endDay && (!this.endDay || !this.hoverEndDay.isEqual(this.endDay.date)) && (!this.startDay || !this.hoverEndDay.isEqual(this.startDay.date))) {
                this.hoverEndDay.deselect();
            }

            // If endday is invalid, return.
            if (!this.provider.isEndValid(day.date)) {
                if (!this.endDay) {
                    this.selectDaysBetween();
                }
                return;
            }

            // If the user hasn't clicked on a startDay yet; or has already clicked on an endDay, return.
            if (!this.startDay || this.endDay) {
                return;
            }

            if (this.checkEndDate(day)) {
                this.selectDaysBetween(day.date);
                this.hoverEndDay = day;
            }
        }

        /**
         * Selects the day that the user clicked on.
         * @param {Day} day
         * @void
         */
        selectDay(day) {

            // Check if a startday has already been selected
            if (!this.startDay) {
                this.selectStart(day);
            } else { // If not, check if the date the user clicked on is a valid startdate, if so select a startdate.
                if (day.isEqual(this.startDay.date)) {
                    this.selectStart();
                } else if (!this.checkEndDate(day)) { // Checks if the user's input was before the first enddate, if that's the case, reselect a startday.
                    this.selectStart(day);
                } else {
                    this.selectEnd(day);
                }
            }
        }

        /**
         * Returns true if the day passed as a parameter isn't before the current arrival date.
         * @param {Day} day
         */
        checkEndDate(day) {
            return !day.isBefore(this.startDay.date);
        }

        /**
         * Selects an arrival date.
         * @param {Day} day
         * @void
         */
        selectStart(day = null) {

            // If start day is invalid, deselect everything.
            if (day && !this.provider.isStartValid(day.date)) {
                this.calendarUI.deselectAll();
                return;
            }

            // If you click on a start day twice, deselect everything.
            if (this.startDay) {
                this.calendarUI.deselectAll();
            }

            this.startDay = day;

            if (day) {
                day.select();
                this.calendarUI.dateFrom = day.date.format('Y-m-d') + ' - ';
                this.calendarUI.dateTo = '';
                this.displayElement.showElement(this.calendarUI.dateDeselect);
                this.displayElement.showElement(this.calendarUI.dateObject);
                this.calendarUI.showDates();
                this.provider.getEndDate(day.date.format('Y-m-d'));
            }

            this.selectEnd();
        }

        /**
         * Selects an departure date.
         * @param {Day} day
         */
        selectEnd(day = null) {

            if (this.endDay) {
                this.endDay.deselect();
            }

            if (day) {
                // Check if clicked date is valid, if not deselect everything.
                if (!this.provider.isEndValid(day.date)) {
                    this.calendarUI.deselectAll();
                    return;
                }
                // Marks the date the user clicked on as an enddate.
                day.select();
                if (window.innerWidth < 1281) {
                    this.calendarUI.showBookOverlay();
                }

                // Displays the Departure date
                this.calendarUI.dateTo = day.date.format('Y-m-d');
                this.calendarUI.showDates();
                this.parent.classList.add('end-date-selected');

                this.displayElement.showElement(this.includedText);
                this.displayElement.showElement(this.optionalText);
            }

            this.endDay = day;

            // Displays Price.
            this.calendarUI.showPrice();

            this.selectDaysBetween(day ? day.date : null);
        }

        /**
         * Marks days in between the arrival date and the departure date.
         * @param {Date} endDay
         */
        selectDaysBetween(endDay = null) {
            this.parent.classList.remove('end-date-selected');
            this.parent.querySelectorAll('.calendar-day.selected-between')
                .forEach(cell =>
                    cell.classList.remove('selected-between')
                );

            if (!this.startDay || !endDay) {
                return;
            }

            for (let day = this.startDay.date.clone().addDays(1); day < endDay; day.addDays(1)) {
                const target = this.parent.querySelector('.calendar-day[data-date="' + day.format('Y-m-d') + '"]');
                if (target) {
                    target.classList.add('selected-between');
                }
            }
            this.parent.classList.add('end-date-selected');
        }

        /**
         * Marks bookable departure dates.
         * @param endDates
         * @void
         */
        markEndDates(endDates) {
            let index = 0;

            let hasDateInSameMonth = false;
            let moveToDate = false;

            endDates.forEach((price, endDate) => {
                const target = document.querySelector('.calendar-day[data-date="' + endDate + '"]');
                this.targetSpan = document.querySelector('.calendar-day[data-date="' + endDate + '"] span');

                if (window.hasInfo) {
                    this.targetSpan.innerHTML = '<br> <span style="margin-right:1px;">&euro;</span>' + Math.ceil(price);
                    target.dataset.price = Math.ceil(price).toString();
                }
                index++;
                target.classList.add('end-date');

                if (new Date(endDate).getMonth() === this.startDay?.date.getMonth()) {
                    hasDateInSameMonth = true;
                } else if (moveToDate === false){
                    moveToDate = new Date(endDate);
                }
            });

            if (! hasDateInSameMonth) {
                // Check if end dates are in the same month as the currently selected start day, if not sroll to the next month.
                if (this.canScroll && index === 0 && this.startDay && !this.isInVIew(moveToDate)) {
                    this.calendarUI.scrollDown();
                }
            }

            this.parent.classList.add('start-selected');
        }

        /**
         *
         * @param date
         * @param {Map} endDates
         */
        disableStartDatesBetween(date, endDates)
        {
            let maxEndDate = null;
            for (const set of endDates) {
                const endDate = new Date(set[0]);

                if (null === maxEndDate) {
                    maxEndDate = endDate;
                } else if (endDate.getTime() > maxEndDate) {
                    maxEndDate = endDate;
                }
            }

            for (let day = date.clone().addDays(1); day < maxEndDate; day.addDays(1)) {
                const target = this.parent.querySelector('.calendar-day[data-date="' + day.format('Y-m-d') + '"]');
                if (target && ! target.classList.contains('end-date')) {
                    target.classList.add('start-unavailable');
                }
            }

            this.parent.classList.add('end-date-selected');
        }

        freeDisabledStartDates()
        {
            this.parent.querySelectorAll('.calendar-day.start-unavailable').forEach((day) => day.classList.remove('start-unavailable'));
        }

        /**
         * Returns true if the currenth month is in view.
         * @param date
         * @returns {boolean}
         */
        isInVIew(date) {
            const monthIndex = new Date().diffInMonths(date);
            return !(monthIndex % 2 === 0 || window.innerWidth < 1281); // Return true if the monthIndex is uneven, or if the user is the large version.
        }


        /**
         * Unmarks all bookable departure dates.
         * @void
         */
        clearEndDates() {
            this.parent.querySelectorAll('.end-date')
                .forEach(cell =>
                    cell.classList.remove('end-date')
                );

            this.parent.querySelectorAll('.end-date .price').forEach(cell => {
                cell.innerHTML = '';
            });

            this.parent.classList.remove('start-selected');
        }
    }

    class DisplayElement {
        /**
         * Hides element with a fading effect.
         * @param element
         * @param fadeSpeed
         * @void
         */
        hideElementFade(element, fadeSpeed) {
            element.classList.add('opacity-0');

            setTimeout(
                () => {
                    if (element.classList.contains('opacity-0')) {
                        element.classList.add('hidden');
                    }
                }, fadeSpeed);
        }

        /**
         * Hides element instantly.
         * @param element
         * @void
         */
        hideElement(element) {
            element.classList.add('hidden');
        }

        /**
         * Shows element.
         * @param element
         * @void
         */
        showElement(element) {
            element.classList.remove('opacity-0');
            element.classList.remove('hidden');
        }
    }


    class CalendarUI {

        constructor(host) {
            this.host = host;

            this.bookOverlay = document.querySelector('.book-overlay');

            /** @type {Element} Book overlay Price */
            this.bookOverlayPrice = document.querySelector('.book-overlay-price');
            this.bookCompanyPrice = document.querySelector('.book-company-price');

            this.firstYear = document.querySelector('.year.first-year');
            this.secondYear = document.querySelector('.year.second-year');

            this.firstYearContent = new Date().getFullYear();
            this.secondYearContent = new Date().addYears(1).getFullYear();

            this.genYearToggles();

            this.firstYear.addEventListener('click', () => {
                this.scrollToYear(event);
            });

            this.secondYear.addEventListener('click', () => {
                this.scrollToYear(event);
            });

            /** @type {Element} */
            this.dateFrom = '';
            this.dateTo = '';
            this.dateObject = document.querySelector('.date-object');

            /** @type {Element} */
            this.deselectButton = document.querySelector('.deselect');
            this.deselectButton.addEventListener('click', () => {
                this.deselectAll();
            });

            this.activateBookOverlayButton = document.querySelector('.activate-book-overlay-button');
            this.activateBookOverlayButton.addEventListener('click', () => {
                this.showBookOverlay();
            });

            /** @type {number} */
            this.currentHeight = 0;

            /** Updates the scrolling size on resize */
            window.addEventListener('resize', () => {
                this.currentHeight = this.host.parent.scrollTop;
                this.scrollFunction();
            })

            /** Calendar navigation buttons */
            this.previous = document.querySelector('.previous');
            this.previous.addEventListener('click', () => {
                this.scrollUp()
            });

            this.next = document.querySelector('.next');
            this.next.addEventListener('click', () => {
                this.scrollDown();
            });

            /** @type {Element} */
            this.buttonContainer = document.querySelector('.scroll-button-container');

            window.addEventListener('click', () => {
                this.hidePanel(event);
            });

            /** @type {Element} */
            this.dateDeselect = document.querySelector('.clear-dates');

            if (this.dateDeselect) {
                this.dateDeselect.addEventListener('click', () => {
                    this.hideBookOverlay();
                    this.deselectAll();
                });
            }
        }

        scrollToYear(event) {

            const yearItem = event.target;
            const year = yearItem.innerHTML;

            for (let index = 0; index < this.host.allTableContainers.length; index++) {
                const tableContainer = this.host.allTableContainers[index];
                const firstIterationYear = tableContainer.querySelector('[data-date^="' + year + '"]');

                if (firstIterationYear) {
                    const monthIndex = new Date().diffInMonths(new Date(firstIterationYear.date));

                    if (window.innerWidth < 1281) {
                        this.currentHeight = this.host.calendarMonthHeight * index;
                    } else if (monthIndex % 2 === 0) {
                        this.currentHeight = Math.max(this.currentHeight = this.host.calendarMonthHeight * index / 2, 0);
                    } else {
                        this.currentHeight = Math.max(this.currentHeight = this.host.calendarMonthHeight * (index - 1) / 2, 0);
                    }
                    this.scrollFunction();
                    break;
                }
            }
        }

        setYearActive(element) {
            document.querySelector('.active')?.classList.remove('active');
            element?.classList.add('active');
        }


        genYearToggles() {
            this.firstYear.innerHTML = this.firstYearContent;
            this.secondYear.innerHTML = this.secondYearContent;
        }

        /**
         * As the name suggests, deselects everything.
         * @void
         */
        deselectAll() {


            this.showPrice(true);

            this.host.displayElement.hideElementFade(this.activateBookOverlayButton, 500);
            this.host.displayElement.hideElementFade(this.deselectButton, 500);

            this.host.startDay ? this.host.startDay.deselect() : '';
            this.host.endDay ? this.host.endDay.deselect() : '';

            this.host.startDay = null;
            this.host.endDay = null;

            this.showDates();

            this.host.displayElement.hideElementFade(this.dateDeselect, 500);
            this.dateObject.innerHTML = window.selectDates;
            this.host.clearEndDates();
            this.host.selectDaysBetween();
            this.host.parent.querySelectorAll('.calendar-day.selected-between')
                .forEach(cell =>
                    cell.classList.remove('selected-between')
                );

            this.host.freeDisabledStartDates();
        }

        /** Shows dates.
         *
         * @void
         */
        showDates() {
            this.dateObject.innerHTML = this.dateFrom + this.dateTo;
        }

        /**
         * Searches for the first month that's available to book, then saves which month it is, and scrolls to it.
         * @void
         */
        checkFirstStartAvailable() {

            for (let index = 0; index < this.host.allTableContainers.length; index++) {
                const tableContainer = this.host.allTableContainers[index];
                const firstStartAvailableContainer = tableContainer.querySelector('.start-available');

                if (firstStartAvailableContainer) {
                    const monthIndex = new Date().diffInMonths(new Date(firstStartAvailableContainer.date));

                    if (window.innerWidth < 1281) {
                        this.currentHeight = this.host.calendarMonthHeight * index;
                    } else if (monthIndex % 2 === 0) {
                        this.currentHeight = Math.max(this.currentHeight = this.host.calendarMonthHeight * index / 2, 0);
                    }
                    this.scrollFunction();
                    break;
                }
            }
        }


        /**
         * Show price if the user has selected an arrival and departure date, and if price information is toggled on.
         * @param removePrice
         * @void
         */
        showPrice(removePrice = null) {

            if (!window.hasInfo) {
                return;
            }

            if (removePrice) {
                this.host.displayElement.hideElementFade(this.bookCompanyPrice, 500);
                return;
            }
            if (this.host.endDay) {
                this.host.displayElement.showElement(this.bookCompanyPrice);
                this.bookOverlayPrice.innerHTML = '€ ' + document.querySelector('.selected.end-date').dataset.price + ', -';
            }
        }

        /**
         * Shows selected travel company.
         * @constructor
         * @void
         */
        showCompany() {
            // Travel company object.
            const company = {
                adults: 0,
                children: 0,
                babies: 0,
                pets: 0,
            }

            // Increments the corresponding input value.
            this.host.companyInputContainer.querySelectorAll('input').forEach(input => {
                company[input.name.replace('input-', '')] = Number(input.value);
            });
            // Calculate the total amount of people selected.
            const totalPeople = company.adults + company.children + Math.max(company.babies - occupationInfo.extraBabies, 0);

            this.host.totalPeople = totalPeople;

            this.host.company = company;

            const companyText = (company.adults + company.children) + ' ' +
                travelCompanyTranslation.adults[company.adults + company.children === 1 ? 0 : 1]; // Check if word should be plural or singular. If there's one person selected, get the first item of the translations array, the first item is the singular version of the word.
            this.host.companyInfo.innerHTML = totalPeople === 0 && company.babies < 1 && company.pets < 1 ? window.selectCompany : companyText;
            this.host.bookCompanyInfo.innerHTML = totalPeople === 0 && company.babies < 1 && company.pets < 1 ? window.selectCompany : companyText;

            const babyText = ', ' + company.babies + ' ' + travelCompanyTranslation.babies[company.babies === 1 ? 0 : 1]; // Check if word should be plural or singular

            // Displays the amount of selected babies if there's one or more babies selected.
            if (company.babies >= 1) {
                this.host.companyInfo.innerHTML += babyText;
                this.host.bookCompanyInfo.innerHTML += babyText;
            }

            const petText = ', ' + company.pets + ' ' + travelCompanyTranslation.pets[company.pets === 1 ? 0 : 1]; // Check if word should be plural or singular

            // Displays the amount of selected pets if there's one or more pets selected.
            if (company.pets >= 1) {
                this.host.companyInfo.innerHTML += petText;
                this.host.bookCompanyInfo.innerHTML += petText;
            }

            // Check if there's one or more adults selected, if so, return true.
            const result = company.adults >= 1 && occupationInfo.numPeople >= totalPeople && occupationInfo.numPets >= company.pets;
            if (result) {
                this.host.provider.cache.clear();
                this.host.displayElement.hideElementFade(document.querySelector('.minimum-select-desc'), 500);
            }
        }

        /**
         *
         * @param event
         * @void
         */
        hidePanel(event = null) {
            // Check if panel is currently opened, then check if there's no event, or the user has clicked anywhere except for the travel company selector.
            if (this.host.companyParent && this.host.companyParent.classList.contains('opened') && (!event || event && event.target.closest('.scrim'))) {
                if (this.host.endDay && this.host.company.adults !== 0) {
                    this.host.provider.netReq();
                }
                closePanel(this.host.companyParent);
            }
        }

        /**
         * Calculates where the user has scrolled to, and adds the height of a month, the value of this.host result gets capped at 0, and the height of the parent.
         * @void
         */
        scrollDown() {
            this.currentHeight = Math.clamp(this.currentHeight + this.host.calendarMonthHeight, 0, this.host.parent.scrollHeight - this.host.calendarMonthHeight);
            this.currentHeight = Math.round(this.currentHeight / this.host.calendarMonthHeight) * this.host.calendarMonthHeight;
            this.scrollFunction();
        }

        /**
         * Calculates where the user has scrolled to, and subtracts the height of a month, the value of this.calendarUI.host result gets capped at 0, and the height of the parent.
         * @void
         */
        scrollUp() {
            this.currentHeight = Math.clamp(this.currentHeight - this.host.calendarMonthHeight, 0, this.host.parent.scrollHeight - this.host.calendarMonthHeight);
            this.currentHeight = Math.round(this.currentHeight / this.host.calendarMonthHeight) * this.host.calendarMonthHeight;
            this.scrollFunction();
        }

        /**
         * Scroll method
         * @void
         */
        scrollFunction() {
            this.host.parent.scroll({
                top: this.currentHeight,
                behavior: !window.chrome ? 'smooth' : 'instant'
            });

            const heightCalculation = this.currentHeight / this.host.calendarMonthHeight;
            let index = window.innerWidth < 1281 ? heightCalculation : heightCalculation * 2; // Keep this a let for when the user resizes the window.
            let maxIndex = window.innerWidth < 1281 ? this.host.allTableContainers.length - 1 : this.host.allTableContainers.length - 2;

            const tableContainer = this.host.allTableContainers[index]; // Current month in view

            if (tableContainer.querySelector('[data-date^="' + this.firstYearContent + '-"]')) { // If the month in view is the first year, set the first year as active
                this.setYearActive(this.firstYear);
            } else {
                this.setYearActive(this.secondYear);
            }

            if (index === 0) {
                this.fadeNavButton(this.previous); // Fade the previous button when you can't go back any further.
            } else if (index === maxIndex) {
                this.fadeNavButton(this.next); // Fade the next button when you can't go any further.
            } else {
                this.fadeNavButton();
            }
        }

        fadeNavButton(buttonToFade = null) {
            this.previous.classList.remove('half-opacity');
            this.next.classList.remove('half-opacity');

            buttonToFade?.classList.add('half-opacity');
        }

        /**
         * Shows book overlay and hides book overlay buttons.
         * @void
         */
        showBookOverlay() {
            this.bookOverlay.scrollIntoView();
            this.host.displayElement.hideElementFade(this.buttonContainer, 500);
            this.host.displayElement.hideElementFade(this.deselectButton, 500);
            this.host.displayElement.hideElementFade(this.activateBookOverlayButton, 500);
        }

        /**
         * Hides book overlay and Shows book overlay buttons.
         * @void
         */
        hideBookOverlay() {
            this.host.displayElement.showElement(this.buttonContainer);
            this.host.displayElement.showElement(this.deselectButton);
            setTimeout(
                () => {
                    this.host.displayElement.showElement(this.activateBookOverlayButton);
                }
                , 100
            )
            document.body.querySelector('.calendar-main').scrollIntoView(true)
        }

        /**
         * If the user hasn't selected an arrival and departure date, alert the user. Otherwise, send the user to the booking process.
         * @void
         */
        book() {
            if (this.host.endDay && this.host.totalPeople !== 0) {
                window.open(window.houseUrl + '/' + this.host.startDay.date.format('d-m-Y') + '/' + this.host.endDay.date.diffInDays(this.host.startDay.date) + "/"+Utils.translate('search.sections.companions.filters.companions.reference')+":" + this.host.company.adults + ',' + this.host.company.children + ',' + this.host.company.babies + ',' + this.host.company.pets + '?s=embed', '_blank');
            } else if (this.host.endDay && this.host.totalPeople === 0) {
                window.open(window.houseUrl + '/' + this.host.startDay.date.format('d-m-Y') + '/' + this.host.endDay.date.diffInDays(this.host.startDay.date) + '?s=embed', '_blank');
            } else {
                window.open(window.houseUrl + '?s=embed', '_blank');
            }
        }

        /**
         * Shows the loader.
         * @void
         */
        showLoader() {
            this.host.displayElement.showElement(this.host.loader);
            this.host.loadIndicator.indeterminate().show().start();
        }

        /**
         * Hides the loader.
         * @void
         */
        hideLoader() {
            this.host.loadIndicator.indeterminate().stop();
            this.host.loadIndicator.indeterminate().hide();
            this.host.displayElement.hideElement(this.host.loader);
        }
    }


    class Month {
        constructor(date, host) {
            this.date = date;
            this.host = host;

            this.render();
            this.bindEvent();
        }

        /**
         * Generates the calendar.
         * @void
         */
        render() {
            let hasAvailabilities = false;

            let html =
                '<h3>'
                + Utils.translate('datetime.months.full.'
                    + (this.date.getMonth() + 1), null, true)
                + '<br>'
                + '<span class="year-text half-opacity">' + this.date.getFullYear() + '</span>'
                + '</h3>'
                + '<table class="calendar" data-date="' + (this.date.format('m-Y')) + '">'
                + '<tr>'
            for (let i = 0; i < 7; i++) {
                html += '<td data-day="' + ((i + 1) % 7 === 0 ? 0 : i + 1) + '" class="tableHeader" >' + Utils.translate('datetime.days.short-2.' + (i + 1)) + '</td>';
            }
            html += '</tr>'

            const daysBeforeMonth = (this.date.getDay() || 7) - 1;
            const daysLastMonth = this.date.clone().subDays(1).getDate();
            const daysInMonth = this.date.getDaysInMonth();
            let numWeeks = 0;
            let i;
            // Shows all days indide of a month
            for (i = 0; i < daysInMonth; i++) {
                // Checks if the week just began. If it did, start a new row.
                if ((i + daysBeforeMonth) % 7 === 0 || i === 0) {
                    html += '<tr>';
                    numWeeks++;

                }

                // Check if the current month just started, if so, display last few days of last month.
                if (i === 0) {
                    for (let j = 0; j < daysBeforeMonth; j++) {
                        html += '<td class="otherMonth calendar-day half-opacity">' + (daysLastMonth - (daysBeforeMonth - j) + 1) + '</td>';
                    }
                }

                const baseDate = this.date.clone().addDays(i);
                const currentDay = baseDate.format('Y-m-d');

                const isOccupied = this.host.provider.isOccupied(currentDay);
                const isValid = this.host.provider.isStartValid(currentDay);

                let classString = (isValid && !isOccupied
                    ? 'start-available'
                    : isOccupied
                        ? 'occupied'
                        : 'start-invalid half-opacity')

                // If there's an availability this month, hasAvailabilities is true.
                if (isValid && !isOccupied) {
                    hasAvailabilities = true;
                }

                let occupationContent = !isOccupied ? (i + 1).toString().padStart(2, '0') : '×';


                html += '<td class="calendar-day '
                    + classString + '" data-date="' + currentDay + '">' + occupationContent +
                    '<span class="price"></span></td>';
                // Check if the week is about to end.
                if ((i + daysBeforeMonth) % 7 === 6) {
                    html += '</tr>';
                }
            }

            // Displays the first few days of the next month.
            while ((i + daysBeforeMonth) % 7 > 0) {
                i++;
                html += '<td class="otherMonth calendar-day">' + (i - daysInMonth).toString().padStart(2, '0');
                html += '</td>';
            }
            // if the week ended, close the row.
            if (i >= daysInMonth) {
                html += '</tr>';
            }

            // Fill in weeks in table until six weeks are displayed
            while (numWeeks < 6) {
                html += '<tr>';
                for (let c = 1; c <= 7; c++) {
                    html += '<td class="otherMonth calendar-day">' + (i + c - daysInMonth).toString().padStart(2, '0');
                    html += '</td>';
                }
                html += '</tr>';
                numWeeks++;
            }

            if (!hasAvailabilities) { // If there's no availabilities this month, display it on the user's screen.
                html += '<div class="no-availabilities">' +
                    '<p> ' + window.noStartDates + ' </p>' +
                    '</div>';
            }

            html += '</table>';

            this.wrapper = document.createElement('div');
            this.wrapper.classList.add('tableContainer')
            this.line = document.createElement('hr');
            this.line.classList.add('vertical-line');
            this.wrapper.innerHTML = html;
            this.host.parent.appendChild(this.wrapper);
            this.host.parent.appendChild(this.line);
        }


        /**
         * Adds eventlisteners to the calendar.
         * @void
         */
        bindEvent() {
            this.wrapper.addEventListener('click', this.onClick.bind(this));
            this.host.parent.addEventListener('mouseover', this.mouseOver.bind(this));
        }

        /**
         *  If you click on an available date, select said date, else deselect everything.
         * @param event
         * @void
         */
        onClick(event) {
            const target = event.target.closest('.calendar-day');

            // Check if the user has clicked on a cell
            if (!target) {
                this.host.calendarUI.deselectAll();
                return;
            }

            this.host.selectDay(new Day(target));
        }

        /**
         * If you hover over an available date, mark said date, else do nothing.
         * @param event
         * @void
         */
        mouseOver(event) {
            const target = event.target.closest('.calendar-day');

            // Check if the user has hovered over a cell
            if (!target && !this.host.endDay) {
                this.host.hoverDay();
                return;
            }

            this.host.hoverDay(new Day(target));
        }
    }

    class Day {
        constructor(target) {
            if (target) {
                this.cell = target;
                this.date = new Date(target.dataset.date);
            }
        }

        /**
         * Returns true if this.date is before the date passed as a parameter.
         * @param date
         * @returns {boolean}
         */
        isBefore(date) {
            return this.date < date;
        }

        /**
         * Returns true if this.date is after the date passed as a parameter.
         * @param date
         * @returns {boolean}
         */
        isAfter(date) {
            return this.date > date;
        }

        /**
         * Returns true if this.date and the date passed as a parameter are at the same time.
         * @param date
         * @returns {boolean}
         */
        isEqual(date) {
            return this.date.getTime() === date.getTime();
        }


        /**
         * Adds 'selected' class to the to be selected cell.
         * @void
         */
        select() {
            this.cell.classList.add('selected');

            this.cell.querySelector('.price').innerHtml = '';
        }

        /**
         * Removes 'selected' class to the to be deselected cell.
         * @void
         */
        deselect() {
            this.cell.classList.remove('selected');
        }
    }

    class AvailabilityProvider {

        constructor(host) {
            this.cache = new Map();
            this.host = host;
            this.startDate = new Set();
            this.endDates = new Map();
            this.occupations = new Set();

            window.availabilities.forEach(availability => {
                this.startDate.add(new Date(availability).format('Y-m-d'));
            });

            window.occupations.forEach(occupation => {
                this.occupations.add(occupation);
            });
        }

        /**
         * Returns true if this.startDate contains the parameter's value.
         * @param {string|Date} date
         * @returns {boolean}
         */
        isStartValid(date) {
            return this.startDate.has(date instanceof Date ? date.format('Y-m-d') : date);
        }

        /**
         * Returns true if this.occupatoins contains the parameter's value
         * @param {string|Date} date
         * @returns {boolean}
         */
        isOccupied(date) {
            return this.occupations.has(date instanceof Date ? date.format('Y-m-d') : date);
        }

        /**
         * this.endDates contains the parameter's value
         * @param {string|Date} date
         * @returns {boolean}
         */
        isEndValid(date) {
            return this.endDates.has(date instanceof Date ? date.format('Y-m-d') : date);
        }


        /**
         * Does a network request to get all enddates, prices, etc.
         * @param currentDate
         * @void
         */
        getEndDate(currentDate) {
            this.currentDate = currentDate;
            this.endDates.clear();

            this.host.canScroll = true;

            if (!this.cache.has(this.currentDate)) {
                this.netReq();
            } else {
                this.processResponse(this.cache.get(this.currentDate));
            }
        }

        /**
         * Network request.
         * @void
         */
        netReq() {
            this.host.calendarUI.showLoader();
            new NetworkRequest(getEndDateUrl.replace('placeholder%date', this.currentDate))
                .withJson({
                    numPeople: this.host.company.adults + this.host.company.children + Math.max(this.host.company.babies - occupationInfo.extraBabies, 0),
                    numPets: this.host.company.pets,
                })
                .post()
                .then(this.reqListener.bind(this));
        }


        /**
         * Request listener.
         * @param {NetworkResponse} response
         * @void
         */
        reqListener(response) {
            const res = response.body;
            this.processResponse(res.endDates);
            this.cache.set(this.currentDate, res.endDates);

            // Updates the price when the user selects different travel company.
            this.host.calendarUI.showPrice();

            this.host.calendarUI.hideLoader()
            this.host.displayElement.showElement(this.host.calendarUI.deselectButton);
        }

        /**
         * @param endDates
         * @void
         */
        processResponse(endDates) {

            endDates.forEach(endDate => {

                // End Dates
                this.endDates.set(
                    new Date(endDate.endsOn).format('Y-m-d'), endDate.price)
            })

            const firstEndDate = endDates[0].additionalCosts;

            this.host.includedText.innerHTML = '';
            this.host.optionalText.innerHTML = '';
            this.host.optionalText.closest('.optional').classList.remove('hidden');

            firstEndDate.included?.forEach(includedCost => {
                this.host.includedText.innerHTML += includedCost.name + (firstEndDate.included.length === firstEndDate.included.indexOf(includedCost) + 1 ? '' : ', ');
            });

            firstEndDate.optional?.forEach(optionalCost => {
                this.host.optionalText.innerHTML += optionalCost.name + (firstEndDate.optional.length === firstEndDate.optional.indexOf(optionalCost) + 1 ? '' : ', ');
            });

            if (! firstEndDate.optional) {
                this.host.optionalText.closest('.optional').classList.add('hidden');
            }

            // Marks endDates
            this.host.markEndDates(this.endDates);
            this.host.displayElement.showElement(this.host.calendarUI.deselectButton);

            this.host.disableStartDatesBetween(new Date(this.currentDate), this.endDates);
        }
    }

// New instance of CalendarDisplay class when the page has fully loaded.
    window.addEventListener('DOMContentLoaded', function () {
        new CalendarDisplay();
    });
}

/**
 * Clamp a number between two values
 * @type {function(number: number, lower: number, upper: number): number}
 */
Math.clamp = Math.clamp || function (number, lower, upper) {
    return this.min(this.max(number, lower), upper);
}



// Node shit
Node.prototype.on = function(type, listenerOrSelector, listenerOrObject, options) {
    EventTarget.prototype.addEventListener.call(this, type, event => {
        // If the 2nd argument is NOT a selector (string), run as normal.
        if (typeof(listenerOrSelector) !== 'string') {
            listenerOrSelector(event);
        } else {
            // See if the selector has a result
            const target = event.target.closest(listenerOrSelector);
            if (target) {
                // Hack in the currentTarget property as it is read-only by default.
                Object.defineProperty(event, 'currentTarget', {
                    value: target,
                    writable: false,
                });

                listenerOrObject(event);
            }
        }
    }, typeof(listenerOrSelector) === 'string' ? options : listenerOrObject);

    return this;
}
